import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { flatMappedStories } from 'pages/currentawareness/Util'
import HomepageStoriesContainer from 'redux/containers/pages/dashboard/HomepageStoriesContainer'
import { StoriesSkeleton } from 'pages/dashboard/Skeleton'

const StoriesWrapper = ({ homepageArticles, aol }) => (
  <ResponseConsumer
    response={homepageArticles}
    pendingComponent={StoriesSkeleton}
    content={() => <HomepageStoriesContainer stories={flatMappedStories(homepageArticles)} aol={aol} />}
  />
)

export default StoriesWrapper
